import { Stack, Typography } from '@mui/material'

import LanguageSelector from '@/components/LanguageSelector'
import { LanguageIcon } from '@/assets/icons/language-icon'

export function LanguageSelectBulkImport({
  language,
  handleLanguage,
  label,
}: {
  language: string
  handleLanguage: (language: string) => void
  label?: string
}) {
  return (
    <Stack gap="6px">
      {label ? (
        <Typography
          sx={{
            fontWeight: 'medium',
            color: '#000',
          }}
        >
          {label}
        </Typography>
      ) : null}

      <LanguageSelector
        icon={
          <Stack
            sx={{
              bgcolor: '#DD2590',
              padding: '6px',
              borderRadius: '12px',
              border: '1.5px solid #FAA7E0',
            }}
          >
            <LanguageIcon />
          </Stack>
        }
        language={language}
        setLanguage={(newLanguage: string) => {
          handleLanguage(newLanguage)
        }}
      />
    </Stack>
  )
}
